import { v4 as uuidv4 } from 'uuid';
import { version } from '@searchspring/snap-toolbox';
export class BeaconEvent {
    constructor(payload) {
        this.type = payload.type;
        this.category = payload.category;
        this.context = payload.context;
        this.meta = payload.meta;
        this.event = payload.event;
        this.id = payload.id;
        this.pid = payload.pid;
        this.meta = {
            initiator: {
                lib: 'searchspring/snap',
                'lib.version': version,
            },
        };
        this.id = uuidv4();
    }
}
